import React, { FC } from "react";
import { useController, useFormContext } from "react-hook-form";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Typography,
} from "@mui/material";

import { BooleanCheckboxInputProps } from "./types";

const StyledFormBooleanCheckbox: FC<BooleanCheckboxInputProps> = (props) => {
  const {
    name,
    title,
    rules,
    label,
    labelSx,
    helperText,
    defaultValue = false,
    onChange: onCheckboxChange,
    ...inputProps
  } = props;

  const formContext = useFormContext();
  const {
    control,
    formState: { errors },
  } = formContext;

  const {
    field: { value = false, onChange },
  } = useController({
    name,
    control,
    rules,

    defaultValue,
  });

  const message = errors?.[name]?.message as string;

  return (
    <Box mb={2} textAlign="left" sx={inputProps.sx}>
      {title && (
        <Typography variant="subtitle2" color="grey800" mb={1}>
          {title}
        </Typography>
      )}
      <FormControl
        error={!!message}
        component="fieldset"
        variant="standard"
        {...inputProps}
      >
        <FormControlLabel
          control={
            <Checkbox
              checked={!!value}
              onChange={(event, checked) => {
                onChange(checked);
                onCheckboxChange?.(event, checked);
              }}
            />
          }
          label={
            <>
              <Typography variant="body2">{label}</Typography>
              {helperText && (
                <Typography
                  sx={{ mt: 0.5 }}
                  variant="subtitle2"
                  color="grey800"
                >
                  {helperText}
                </Typography>
              )}
            </>
          }
          sx={labelSx}
        />
        {message && <FormHelperText>{message}</FormHelperText>}
      </FormControl>
    </Box>
  );
};

export default StyledFormBooleanCheckbox;
